import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Status } from './models/imageInfo.interface';

@Component({
  selector: 'ife-image-picker',
  templateUrl: './image-picker.component.html',
  styleUrls: ['./image-picker.component.scss'],
})
export class ImagePickerComponent {
  @Input()
  imageUrl: string;
  @Output()
  selectImage: EventEmitter<any[]> = new EventEmitter<any[]>();
  readonly statusEn = Status;
  status = Status.init;

  constructor(private toastr: ToastrService, private translate: TranslateService) {}

  setStatus(status: Status) {
    this.status = status;
  }

  sendImage(image: any) {
    // 10Mib
    const maxFileSize = 10485760;
    const reader = new FileReader();
    const imageFile = image.target.files[0];
    if (imageFile.size >= maxFileSize) {
      this.toastr.error(this.translate.instant('errorMessages.imageToLarge'));
      return;
    }
    this.setStatus(Status.loading);

    reader.addEventListener('load', (event: any) => {
      this.selectImage.emit([imageFile, this.setStatus.bind(this)]);
    });

    reader.readAsDataURL(imageFile);
  }
}
